import {PureComponent} from 'react'
import PropTypes from 'prop-types'

import './JsonViewer.scss'

const TOKEN_REGEX = /("(?:\\u[a-fA-F0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\btrue\b|\bfalse\b|\bnull\b|-?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?)/g

function tokenize(json) {
  const tokens = []
  let lastIndex = 0
  let key = 0
  let match

  while ((match = TOKEN_REGEX.exec(json)) !== null) {
    if (match.index > lastIndex) {
      tokens.push({key: key++, type: 'punctuation', text: json.slice(lastIndex, match.index)})
    }

    const value = match[0]
    let type = 'number'
    if (value.startsWith('"')) {
      type = match[2] ? 'key' : 'string'
    } else if (value === 'true' || value === 'false') {
      type = 'boolean'
    } else if (value === 'null') {
      type = 'null'
    }

    tokens.push({key: key++, type, text: value})
    lastIndex = TOKEN_REGEX.lastIndex
  }

  if (lastIndex < json.length) {
    tokens.push({key: key++, type: 'punctuation', text: json.slice(lastIndex)})
  }

  return tokens
}

export default class JsonViewer extends PureComponent {
  static propTypes = {
    data: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
    className: PropTypes.string,
  }

  static defaultProps = {
    data: null,
    className: '',
  }

  render() {
    const {data, className} = this.props

    if (data === null || data === undefined) {
      return null
    }

    let parsed = data
    if (typeof data === 'string') {
      try {
        parsed = JSON.parse(data)
      } catch (e) {
        parsed = data
      }
    }

    const json = typeof parsed === 'string' ? parsed : JSON.stringify(parsed, null, 2)

    return (
      <pre className={`json-viewer ${className}`}>
        {tokenize(json).map(token => (
          <span key={token.key} className={`json-viewer__${token.type}`}>{token.text}</span>
        ))}
      </pre>
    )
  }
}
